import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Typography } from "@mui/material";

import layoutIllustrations from "../../../assets/layoutEdit.svg";
import { ClientsContext } from "../context/ClientsContextProvider";
import { Client, PostClient } from "../types";
import { clientsApi } from "../../../services/api";
import { useNavigate } from "react-router-dom";
import { NoChangesOnClientEditModal } from "./NoChangesOnClientEditModal";
import { MainContext } from "../../../main/context/MainContextProvider";

const schema = yup.object().shape({
  selectedLayoutId: yup.string(),
});

export type ClientLayoutData = yup.InferType<typeof schema>;

const ClientLayoutForm = React.forwardRef((_, ref) => {
  const { client } = useContext(ClientsContext);
  const { isMobile } = useContext(MainContext);
  const { handleSubmit } = useForm({
    resolver: yupResolver(schema),
  });
  const [openNoChangesModal, setOpenNoChangesModal] = React.useState(false);

  const navigate = useNavigate();
  function updateData() {
    //   if (!data) return;
    //   setValue("concessionairePhone", data.concessionairePhone);
    //   setValue("concessionaireEmail", data.concessionaireEmail);
    //   setValue("internetProviders", data.internetProviders);
  }
  useEffect(() => {
    updateData();
  }, [client]);
  const onSubmit = async (_: ClientLayoutData) => {
    //   const support = supportDataToSupport(data);
    const collaboratorsListLength = client?.collaboratorsList?.length ?? 0;
    const newClientData: PostClient | Client = {
      collaboratorsList:
        collaboratorsListLength > 0 ? client?.collaboratorsList : undefined,
      ...client,
    };
    //   setClient(newClientData);
    const path = window.location.pathname;
    const isRegister = path.includes("cadastrar");
    if (isRegister) {
      await clientsApi.postClient(newClientData);
      navigate("/clients");
    }
  };

  React.useImperativeHandle(ref, () => ({
    async submitForm() {
      await handleSubmit(onSubmit)();
    },
  }));
  return (
    <>
      <form
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div
          style={{
            width: "80%",
            paddingBottom: "20px",
          }}
        >
          <>
            <div
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                textAlign: "start",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", marginBottom: "10px" }}
              >
                Layout Padrão do Cliente
              </Typography>
            </div>
            <div
              style={{
                width: isMobile ? "" : "100%",
                height: isMobile ? "200px" : "100%",
                minWidth: isMobile ? "" : "400px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img src={layoutIllustrations} alt="logo" />
            </div>
          </>
        </div>
      </form>
      <NoChangesOnClientEditModal
        open={openNoChangesModal}
        setOpen={setOpenNoChangesModal}
      />
    </>
  );
});

export default ClientLayoutForm;
